var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__submit"},[_c('div',{staticClass:"form__item form__item_submit"},[_c('label',[_c('input',{staticClass:"form__item-input",attrs:{"type":"submit","disabled":_vm.disabled},domProps:{"value":_vm.label}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }